import { Slide } from "@/interfaces/meeting/details";

export enum MediaTypes {
  YOUTUBE = "youtube",
  VIDEO = "video",
  VIMEO = "vimeo",
  IMAGE = "image",
  IFRAME = "iframe",
  PDF = "pdf",
  CHAT = "chat",
  SCREENSHARE = "screenshare",
  CART = "cart",
  HTML = "html",
  GIPT = "gipt",
  CREATIVES = "creatives"
}

// TODO use a backend preview url (non static) similar to rep preview's screenshots
export const MainChatSlide: Slide = {
  id: "waiting room",
  clientTitle: "Your dedicated sales representative will be with you shortly",
  media: {
    kind: MediaTypes.IMAGE,
    location: `https://cdn.24slides.com/presentbetter/wp-content/uploads/2019/10/ezgif.com-video-to-gif-2.gif`
  }
};
